<script setup lang="ts">
import LegacyWorkspace from '../components/LegacyWorkspace.vue';
</script>

<template>
  <main class="workspace-view">
    <LegacyWorkspace />
  </main>
</template>

<style scoped>
.workspace-view { min-height: 100dvh; }
</style>
